import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=c6261902&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6261902",
  null
  
)

export default component.exports